import { GetterTree } from 'vuex';
import { DexUserState } from './state';
import RootState from '@/store/root_state';

const getters: GetterTree<DexUserState, RootState> = {
  dexUser: (state, getters) => {
    return state.dexUser;
  },
};

export default getters;
